import { html } from '@microsoft/fast-element';
import type { NegotiationDetailModal } from './negotiation-detail-modal';

export const NegotiationDetailModalTemplate = html<NegotiationDetailModal>`
  <right-side-modal
    classes="user-modal"
    :show="${(x) => x.show}"
    @modalClosing=${(x) => x.closeModal()}
    width="${(x) => x.width}"
    header="${(x) => x.title}"
    buttons="false"
    closeModalHeader="${(x) => x.closeModal()}"
    closeModalDescription="${(x) => x.closeModal()}"
  >
    <execution-drilldown :negotiation=${(x) => x.selectedNegotiation} 
      isNegotiationDetails=${true}
    ></execution-drilldown>
  </right-side-modal>
`;
